import React, { useRef } from 'react';
import logoSrc from '../img/logo.png'; // Assuming the logo is stored in the img folder
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.



function ProjectDevelopment() {
  const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };


  return (
    <>
    
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      <section className="banner-section" id="sectionBanner">  
        <div className="banner-container">
          {/* Left Side Content */}
          <div className="banner-text">
            <h1 className="banner-title" id="titulli">ideas to reality, step by step</h1>
            <p className="banner-description">
              At Shigjeta, we specialize in organizing and planning all variables of your project, from material selection and budgeting to task allocation. Our approach ensures smooth execution and successful project completion.
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>
          </div>
        
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Premium Services Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
              alt="img"
            />
      </div>
      <section className="about-section">
        {/* What is Project Development */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>What is Project Development?</strong></h2>
            <p>
              Project development involves organizing and planning all the variables that go into a project, including deciding materials, creating a budget, and creating tasks for team members. It also involves the processes needed to complete a project, like changing the plans throughout project completion and identifying areas of improvement to help the project run more smoothly.
            </p>
            <ul>
              <li><strong>Goals:</strong> Intended outcomes that the project aims to accomplish, encompassing both long-term and short-term objectives.</li>
              <li><strong>Timeline:</strong> A schedule outlining when team members should complete their tasks, ensuring coordination and timely execution.</li>
              <li><strong>Materials:</strong> Resources and equipment necessary for project completion.</li>
              <li><strong>Budget:</strong> The total financial allocation for the project, determined by material and labor costs.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps3.1.png" alt="Project Development Overview" />
          </div>
        </div>

        {/* Our Project Development Process */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Our Project Development Process</strong></h2>
            <p>
              We follow a structured approach to project development, ensuring each phase is meticulously planned and executed:
            </p>
            <ul>
              <li><strong>Initiation:</strong> Starting up a new project by defining its purpose and scope.</li>
              <li><strong>Planning:</strong> Developing a roadmap that outlines timelines, resources, and budget.</li>
              <li><strong>Execution:</strong> Implementing the project plan by coordinating people and resources.</li>
              <li><strong>Controlling:</strong> Monitoring progress and making necessary adjustments to stay on track.</li>
              <li><strong>Closing:</strong> Finalizing all activities to formally complete the project.</li>
            </ul>
          </div>
          <div className="about-image">
            <img src="/img/ps3.2.png" alt="Project Development Process" />
          </div>
        </div>

        {/* Why Choose Shigjeta */}
        <div className="about-row">
          <div className="about-text">
            <h2><strong>Why Choose Shigjeta?</strong></h2>
            <p>
              With a dedicated team and a comprehensive approach, Shigjeta ensures that your project is handled with the utmost professionalism and efficiency. Our commitment to excellence guarantees that all aspects of your project are meticulously managed, leading to successful outcomes.
            </p>
          </div>
          <div className="about-image">
            <img src="/img/ps3.3.png" alt="Why Choose Shigjeta" />
          </div>
        </div>

        {/* Success Stories */}
        <div className="about-row reverse">
          <div className="about-text">
            <h2><strong>Success Stories</strong></h2>
            <p>
              Our project development services have empowered numerous businesses to achieve their goals efficiently. Explore our success stories to see how we've made a difference.
            </p>
            <a href='/blog' className="cta-button">Read Success Stories</a>
          </div>
          <div className="about-image">
            <img src="/img/ps3.4.png" alt="Success Stories" />
          </div>
        </div>
      </section>
      <ContactForm ref={contactFormRef} />
    </>
  );
}

export default ProjectDevelopment;
